import SearchPageComponent from '../../components/SearchPage.js';
import MultiLocationSearchComponent from '../../components/MultiLocationSearch.js';
import TopFiltersComponent from '../../components/TopFilters.js';
import ListingPriceHistoryChart from '../../components/ListingPriceHistoryChart.js';
const Alpine = window.Alpine;

Alpine.data('SearchPageComponent', SearchPageComponent);
Alpine.data('MultiLocationSearchComponent', MultiLocationSearchComponent);
Alpine.data('TopFiltersComponent', TopFiltersComponent);
Alpine.data('ListingPriceHistoryChart', ListingPriceHistoryChart);
